module.exports = __webpack_public_path__ + "img/Exporting.fe1e970f.png";